export const notification = {
    en: [
        {
            icon: "fas fa-exclamation-triangle",
            content: "Curabitur id eros quis nunc suscipit blandit"
        },
        {
            icon: "fas fa-archive",
            content: "Duis malesuada justo eu sapien elementum, in semper diam posuere"
        },
        {
            icon: "fas fa-cart-plus",
            content: "Donec at nisi sit amet tortor commodo porttitor pretium a erat"
        },
        {
            icon: "fas fa-exclamation-triangle",
            content: "In gravida mauris et nisi"
        },
        {
            icon: "fas fa-cart-plus",
            content: "Curabitur id eros quis nunc suscipit blandit"
        }
    ],
    ru: [
            {
                icon: "fas fa-exclamation-triangle",
                content: "Curabitur id eros quis nunc suscipit blandit"
            },
            {
                icon: "fas fa-archive",
                content: "Duis malesuada justo eu sapien elementum, in semper diam posuere"
            },
            {
                icon: "fas fa-cart-plus",
                content: "Donec at nisi sit amet tortor commodo porttitor pretium a erat"
            },
            {
                icon: "fas fa-exclamation-triangle",
                content: "In gravida mauris et nisi"
            },
            {
                icon: "fas fa-cart-plus",
                content: "Curabitur id eros quis nunc suscipit blandit"
            }
    ],
    uz: [
        {
            icon: "fas fa-exclamation-triangle",
            content: "Curabitur id eros quis nunc suscipit blandit"
        },
        {
            icon: "fas fa-archive",
            content: "Duis malesuada justo eu sapien elementum"
        },
        {
            icon: "fas fa-cart-plus",
            content: "Donec at nisi sit amet tortor commodo porttitor "
        },
        {
            icon: "fas fa-exclamation-triangle",
            content: "In gravida mauris et nisi"
        },
        {
            icon: "fas fa-cart-plus",
            content: "Curabitur id eros quis nunc suscipit blandit"
        }
    ]
}